// // src/pages/PayNow.js
// import React, { useState } from "react";
// import axios from "axios";

// function loadRazorpayScript() {
//   return new Promise((resolve, reject) => {
//     if (window.Razorpay) return resolve(true);
//     const script = document.createElement("script");
//     script.src = "https://checkout.razorpay.com/v1/checkout.js";
//     script.onload = () => resolve(true);
//     script.onerror = () => reject(new Error("Razorpay script failed to load"));
//     document.body.appendChild(script);
//   });
// }

// export default function PayNow() {
//   const [amount, setAmount] = useState(65000); // rupees
//   const [loading, setLoading] = useState(false);

//   const handlePayment = async (e) => {
//     e.preventDefault();
//     setLoading(true);

//     try {
//       // 1) ensure backend reachable: create order (amount in paise)
//       const paise = Math.round(Number(amount) * 100);
//       if (!paise || paise <= 0) throw new Error("Enter a valid amount");

//       const res = await axios.post("/api/payment/create-order", { amount: paise });
//       // If backend returns HTML or 404, this will likely throw or res.data won't have id
//       const order = res.data;
//       if (!order || !order.id) {
//         console.error("create-order response:", res);
//         throw new Error("Order creation failed");
//       }

//       // 2) load Razorpay script if necessary
//       await loadRazorpayScript();

//       const options = {
//         key: process.env.REACT_APP_RAZORPAY_KEY_ID || "<YOUR_PUBLIC_KEY>", // public key OK to expose
//         amount: order.amount,
//         currency: order.currency || "INR",
//         name: "Concerted Path",
//         description: "Course fee",
//         order_id: order.id,
//         handler: async function (razorpayRes) {
//           // verify on server
//           try {
//             const verifyRes = await axios.post("/api/payment/verify", {
//               razorpay_order_id: razorpayRes.razorpay_order_id,
//               razorpay_payment_id: razorpayRes.razorpay_payment_id,
//               razorpay_signature: razorpayRes.razorpay_signature
//             });
//             if (verifyRes.data && verifyRes.data.success) {
//               alert("Payment successful and verified!");
//               // do any post-payment UI / DB updates here
//             } else {
//               alert("Payment processed but verification failed.");
//             }
//           } catch (err) {
//             console.error("verify error", err);
//             alert("Payment made but verification failed on server");
//           }
//         },
//         prefill: {
//           name: "",
//           email: "",
//           contact: ""
//         },
//         theme: { color: "#D4AF37" }
//       };

//       const rzp = new window.Razorpay(options);
//       rzp.on("payment.failed", function (response) {
//         console.error("payment.failed", response);
//         alert("Payment failed: " + (response.error && response.error.description));
//       });
//       rzp.open();

//     } catch (err) {
//       console.error("handlePayment error:", err);
//       // If backend was not reachable you'll usually see an error here or in network tab
//       alert("Payment initiation failed.\n" + (err.message || JSON.stringify(err)));
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <div className="container my-5">
//       <div className="card p-4 mx-auto" style={{maxWidth:800}}>
//         <h2>Payment Page</h2>
//         <form onSubmit={handlePayment}>
//           <div className="mb-3">
//             <label>Amount (INR)</label>
//             <input className="form-control" type="number" value={amount} onChange={(e)=>setAmount(e.target.value)} />
//             <small className="text-muted">Enter amount in rupees (eg. 65000).</small>
//           </div>

//           <button className="btn btn-gold w-100" type="submit" disabled={loading}>
//             {loading ? "Please wait..." : `Pay ₹${amount}`}
//           </button>
//         </form>
//       </div>
//     </div>
//   );
// }


// src/pages/PayNow.js
import React, { useState } from "react";
import api from "../utils/api"; // ✅ CHANGED

function loadRazorpayScript() {
  return new Promise((resolve, reject) => {
    if (window.Razorpay) return resolve(true);
    const script = document.createElement("script");
    script.src = "https://checkout.razorpay.com/v1/checkout.js";
    script.onload = () => resolve(true);
    script.onerror = () => reject(new Error("Razorpay script failed to load"));
    document.body.appendChild(script);
  });
}

export default function PayNow() {
  const [amount, setAmount] = useState(65000);
  const [loading, setLoading] = useState(false);

  const handlePayment = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const paise = Math.round(Number(amount) * 100);
      if (!paise || paise <= 0) throw new Error("Enter a valid amount");

      // ✅ CHANGED
      const res = await api.post("/api/payment/create-order", { amount: paise });

      const order = res.data;
      if (!order || !order.id) {
        console.error("create-order response:", res);
        throw new Error("Order creation failed");
      }

      await loadRazorpayScript();

      const options = {
        key: process.env.REACT_APP_RAZORPAY_KEY_ID || "<YOUR_PUBLIC_KEY>",
        amount: order.amount,
        currency: order.currency || "INR",
        name: "Concerted Path",
        description: "Course fee",
        order_id: order.id,

        handler: async function (razorpayRes) {
          try {
            // ✅ CHANGED
            const verifyRes = await api.post("/api/payment/verify", {
              razorpay_order_id: razorpayRes.razorpay_order_id,
              razorpay_payment_id: razorpayRes.razorpay_payment_id,
              razorpay_signature: razorpayRes.razorpay_signature
            });

            if (verifyRes.data && verifyRes.data.success) {
              alert("Payment successful and verified!");
            } else {
              alert("Payment processed but verification failed.");
            }

          } catch (err) {
            console.error("verify error", err);
            alert("Payment made but verification failed on server");
          }
        },

        prefill: {
          name: "",
          email: "",
          contact: ""
        },

        theme: { color: "#D4AF37" }
      };

      const rzp = new window.Razorpay(options);

      rzp.on("payment.failed", function (response) {
        console.error("payment.failed", response);
        alert("Payment failed: " + (response.error && response.error.description));
      });

      rzp.open();

    } catch (err) {
      console.error("handlePayment error:", err);
      alert("Payment initiation failed.\n" + (err.message || JSON.stringify(err)));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container my-5">
      <div className="card p-4 mx-auto" style={{maxWidth:800}}>
        <h2>Payment Page</h2>

        <form onSubmit={handlePayment}>
          <div className="mb-3">
            <label>Amount (INR)</label>
            <input
              className="form-control"
              type="number"
              value={amount}
              onChange={(e)=>setAmount(e.target.value)}
            />
            <small className="text-muted">
              Enter amount in rupees (eg. 65000).
            </small>
          </div>

          <button
            className="btn btn-gold w-100"
            type="submit"
            disabled={loading}
          >
            {loading ? "Please wait..." : `Pay ₹${amount}`}
          </button>
        </form>
      </div>
    </div>
  );
}
